const removeHideReceiptListing = _ref => {
  let {
    types
  } = _ref;
  return payload => dispatch => {
    dispatch({
      type: types.REMOVE_HIDE_RECEIPT_LISTING,
      payload: {
        ...payload
      }
    });
  };
};
export default removeHideReceiptListing;